<template>
  <base-content>
    <h3 class="tw-text-gray-700 tw-text-xl tw-font-normal">Not Authorized</h3>
    <div class="tw-text-gray-700 tw-text-md tw-mt-2">You are not authorized to view this content.</div>
  </base-content>
</template>
<script>
export default {
  name: "NotAuthorizedView",
};
</script>
